module.exports = __webpack_public_path__ + "img/IT0002489834883.f2b637a4.png";